import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { VatRateDto } from "../vatRate/vatRateDto.model";
import { VatPatternDto } from "./vatpatterndto";

export class VatConfigPatternDto {
    idVatConfigPattern?: number;
    euIndicator?: string;
    countryCode?: number;
    communityCode?: number;
    provinceCode?: number;
    vatPatternDto? : VatPatternDto;
    vatRateDto?: VatRateDto;

    constructor(data?: Partial<VatRateDto>) {
        Object.assign(this, data);
    }
}

export class VatConfigPatternResponse {
    vatConfigPatternDto: VatConfigPatternDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class VatConfigPatternRequest {
    vatConfigPatternDto: VatConfigPatternDto = new VatConfigPatternDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}